import React from "react";
import { ClipLoader } from "react-spinners";
import { Overlay, OverlayText } from "./styles";

const SPINNER_COLOR = "#F15922";

/**
 * Full-screen loading overlay with backdrop blur and fade-in animation.
 * Renders nothing when inactive.
 */
const LoadingOverlay = ({ active = false, spinner = true, text, children }) => {
  return (
    <>
      {active && (
        <Overlay role="status" aria-live="polite">
          {spinner && <ClipLoader color={SPINNER_COLOR} size={48} speedMultiplier={0.8} />}
          {text && <OverlayText>{text}</OverlayText>}
        </Overlay>
      )}
      {children}
    </>
  );
};

export default LoadingOverlay;
